import { FC, ReactNode } from "react";
import { TextField, Typography } from "@mui/material";
import { FormikErrors, FormikTouched, FormikValues } from "formik";

const noop = () => {
  /* no-op */
};

interface FormFieldProps {
  label: string;
  id: string;
  type?: string;
  placeholder?: string;
  value?: any;
  onChange?: (e: React.ChangeEvent<any>) => void;
  onBlur?: (e: React.FocusEvent<any, Element>) => void;
  touched: FormikTouched<FormikValues>;
  errors: FormikErrors<FormikValues>;
  multiline?: boolean;
  rows?: number;
  required?: boolean;
  disabled?: boolean;
  fullWidth?: boolean;
  children?: ReactNode; // For custom input components
  labelProps?: {
    fontWeight?: number;
    alignSelf?: string;
  };
}

const FormField: FC<FormFieldProps> = ({
  label,
  id,
  type = "text",
  placeholder,
  value,
  onChange,
  onBlur,
  touched,
  errors,
  multiline = false,
  rows = 1,
  required = false,
  disabled = false,
  fullWidth = true,
  children,
  labelProps = { fontWeight: 600 },
}) => {
  const fieldTouched = touched[id];
  const fieldError = errors[id] as string;

  return (
    <>
      <Typography
        fontWeight={labelProps.fontWeight}
        alignSelf={labelProps.alignSelf}
      >
        {label}
        {required && " *"}
      </Typography>
      {children ? (
        children
      ) : (
        <TextField
          placeholder={placeholder}
          id={id}
          name={id}
          type={type}
          value={value || ""}
          onChange={onChange || noop}
          onBlur={onBlur || noop}
          helperText={fieldTouched && fieldError}
          error={fieldTouched && !!fieldError}
          margin="dense"
          variant="outlined"
          fullWidth={fullWidth}
          multiline={multiline}
          rows={multiline ? rows : undefined}
          disabled={disabled}
        />
      )}
    </>
  );
};

export default FormField;
